<app-header *ngIf="!hiddenHeader"></app-header>
<div class="wrap-content">
  <router-outlet></router-outlet>
</div>